import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AdPlusSidenavComponent } from './adplus-sidenav.component';
import { IhmLinkModule } from '../ihm-link/ihm-link.module';

@NgModule({
  imports: [CommonModule, RouterModule, MatTooltipModule, IhmLinkModule],
  declarations: [AdPlusSidenavComponent],
  exports: [AdPlusSidenavComponent]
})
export class AdPlusSidenavModule {}
